import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export const ListTitle = styled.h1`
  text-align: center;
  margin: 80px 0;
`;

export const ListWrapper = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(auto-fill, minmax(365px, 1fr));
  grid-gap: 20px;
  align-items: center;
  margin: 20px auto;

  @media ${({ theme }) => theme.media.largeDesktop} {
    margin: 60px auto;
    grid-gap: 30px;
  }
`;

export const CardWrapper = styled.div<{
  children: ReactNode;
  promoted?: boolean;
}>`
  height: 100%;
  width: 100%;
  max-width: calc(100vw - 20px);
  margin: 0 auto;

  ${({ promoted }) => css`
    @media ${({ theme }) => theme.media.tablet} {
      grid-column: ${promoted ? 'span 2' : 'span 1'};
    }
  `}

  a {
    height: 100%;
  }
`;
